import { N26OktaAuth, type N26OktaAuthConfig } from '@n26/okta-auth-client'
import { setAccessTokenProvider } from '@/shared/api/accessToken'
import { env } from '@/shared/config/env'

const required = (name: string, value: string | undefined): string => {
  if (!value) throw new Error(`${name} is not set, see .env.example`)
  return value
}

export const initOktaAuth = (): N26OktaAuth => {
  const config: N26OktaAuthConfig = {
    clientId: required('VITE_OKTA_CLIENT_ID', env.oktaClientId),
    issuer: required('VITE_OKTA_ISSUER', env.oktaIssuer),
    redirectUri: `${window.location.origin}/login/callback`,
  }

  const oktaAuth = new N26OktaAuth(config)
  setAccessTokenProvider(
    () =>
      oktaAuth.n26AuthStateManager.getAuthState()?.accessToken?.accessToken ??
      null
  )
  return oktaAuth
}

let instance: N26OktaAuth | undefined

/** The app's single Okta client, created on first use rather than on import. */
export const getOktaAuth = (): N26OktaAuth => (instance ??= initOktaAuth())
